import React from "react";
import { Container } from "Components/ReactstrapSlim";

import classes from "./PricingSectionTitleBlock.module.scss";

const PricingSectionTitleBlock: React.FC = () => {
   return (
      <Container className={classes.container}>
         <h1 className={classes.title}>LiquidSpace Pricing & Plans</h1>
         <h2 className={classes.subtitle}>
            Explore options for individuals and organizations
         </h2>
      </Container>
   );
};

export default PricingSectionTitleBlock;
